import {
    Button,
    Card,
    Input,
    Modal,
    notification,
    Skeleton,
    Form,
    Popconfirm,
    Select,
    Tooltip,
} from "antd";
import PhoneInput from "react-phone-input-2";
import React, { useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import {
    ApartmentOutlined,
    DeleteOutlined,
    EditOutlined,
    MailOutlined,
    PhoneOutlined,
    PlusOutlined,
    QuestionCircleOutlined,
    ShopOutlined,
    TeamOutlined,
} from "@ant-design/icons";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { getUserRole, vendorTypes } from "../../services/util";
import "./Table.css";

const { Option } = Select;

function VendorList() {
    const [form] = Form.useForm();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const userRole = getUserRole();
    const [searchKey, setSearchKey] = useState("");
    const [formData, setFormData] = useState({
        staff_id,
        sort_by: "id",
        sorting: 1,
        page: 0,
        limit: 10,
        filters: {},
        search_by: searchKey,
    });
    const [formPhoneInputValue, setFormPhoneInputValue] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [title, setTitle] = useState("Edit");
    const [hotelOptions, setHotelOptions] = useState([]);

    const neutralActionButtonStyle = {
        background: "var(--color-bg-elevated)",
        border: "1px solid var(--color-border)",
        borderRadius: 7,
        width: 30,
        height: 30,
    };

    const errorActionButtonStyle = {
        background: "var(--color-error-light)",
        border: "1px solid var(--color-border)",
        borderRadius: 7,
        width: 30,
        height: 30,
    };

    const pillStyle = (type = "primary") => {
        const styles = {
            primary: {
                background: "var(--color-primary-light)",
                border: "1px solid var(--color-border)",
                color: "var(--color-primary)",
            },
            accent: {
                background: "var(--color-accent-light)",
                border: "1px solid var(--color-border)",
                color: "var(--color-accent)",
            },
            muted: {
                background: "var(--color-bg-elevated)",
                border: "1px solid var(--color-border)",
                color: "var(--color-text-secondary)",
            },
        };

        return {
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "2px 10px",
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.4,
            ...styles[type],
        };
    };

    const emptyText = (label = "Not available") => (
        <span style={{ color: "var(--color-text-muted)", fontSize: 12 }}>
            {label}
        </span>
    );

    const renderVendorIdentity = (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: 10,
                    background: "var(--color-primary-light)",
                    border: "1px solid var(--color-border)",
                    color: "var(--color-primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <ApartmentOutlined style={{ fontSize: 14 }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <span
                    style={{
                        color: "var(--color-text)",
                        fontSize: 13,
                        fontWeight: 600,
                    }}
                >
                    {record.vendor_name || "Unnamed vendor"}
                </span>
                <span
                    style={{
                        color: "var(--color-text-muted)",
                        fontSize: 11,
                    }}
                >
                    Vendor ID {record.id}
                </span>
            </div>
        </div>
    );

    const renderPersonCell = (value) =>
        value ? (
            <span style={{ color: "var(--color-text)", fontSize: 13 }}>
                {value}
            </span>
        ) : (
            emptyText("No person assigned")
        );

    const renderEmailCell = (value) =>
        value ? (
            <span
                style={{
                    color: "var(--color-text-secondary)",
                    fontSize: 12,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                }}
            >
                <MailOutlined
                    style={{ fontSize: 11, color: "var(--color-text-muted)" }}
                />
                {value}
            </span>
        ) : (
            emptyText("No email added")
        );

    const renderHotelChips = (hotelIds) => {
        const hotelNames =
            hotelIds?.map((item) => {
                const hotelDetails = hotelOptions.find(
                    (e) => e.hotel_id == item || e.id == item,
                );
                return hotelDetails?.hotel_name || hotelDetails?.name;
            }) || [];

        const filteredNames = hotelNames.filter(Boolean);

        if (!filteredNames.length) {
            return emptyText("No hotels linked");
        }

        return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {filteredNames.map((name, index) => (
                    <span key={`${name}-${index}`} style={pillStyle("primary")}>
                        <ShopOutlined style={{ fontSize: 11 }} />
                        {name}
                    </span>
                ))}
            </div>
        );
    };

    const renderVendorType = (value) => {
        const label = vendorTypes.find((v) => v.key == value)?.name;
        return label ? (
            <span style={pillStyle("accent")}>
                <TeamOutlined style={{ fontSize: 11 }} />
                {label}
            </span>
        ) : (
            emptyText("Type not set")
        );
    };

    const renderPhoneCell = (_, record) =>
        record.phone_number ? (
            <span
                style={{
                    color: "var(--color-text-secondary)",
                    fontSize: 12,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                }}
            >
                <PhoneOutlined
                    style={{ fontSize: 11, color: "var(--color-text-muted)" }}
                />
                {`${record.country_code || ""} ${record.phone_number}`.trim()}
            </span>
        ) : (
            emptyText("No phone added")
        );

    const renderNotesCell = (text) =>
        text && text.trim() !== "" ? (
            <Tooltip placement="rightTop" title={text}>
                <span style={{ color: "var(--color-text)", fontSize: 13 }}>
                    {text.length <= 20 ? text : `${text.substring(0, 20)}...`}
                </span>
            </Tooltip>
        ) : (
            emptyText("No notes added")
        );

    const columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            sorter: () => {},
            width: 100,
        },
        {
            title: "Vendor",
            dataIndex: "vendor_name",
            key: "vendor_name",
            sorter: () => {},
            render: (_, record) => renderVendorIdentity(_, record),
        },
        {
            title: "Person Name",
            dataIndex: "person_name",
            key: "person_name",
            sorter: () => {},
            render: (text) => renderPersonCell(text),
        },
        {
            title: "Email",
            dataIndex: "person_email",
            key: "person_email",
            sorter: () => {},
            render: (text) => renderEmailCell(text),
        },
        {
            title: "Hotel",
            dataIndex: "hotel_id",
            key: "hotel_id",
            render: (record) => renderHotelChips(record),
        },
        {
            title: "Vendor Type",
            dataIndex: "vendor_type",
            key: "vendor_type",
            filters: [
                ...vendorTypes.map((v) => {
                    return { text: v.name, value: v.key };
                }),
            ],
            render: (text) => {
                return renderVendorType(text);
            },
            width: "10%",
            // sorter: () => {},
        },
        {
            title: "Phone",
            render: (_, record) => renderPhoneCell(_, record),
        },
        {
            title: "Notes",
            dataIndex: "notes",
            key: "notes",
            render: (text) => renderNotesCell(text),
            sorter: () => {},
        },
        {
            title: "Action",
            fixed: "right",
            width: 88,
            render: (text, record) => {
                return (
                    <div style={{ display: "flex", gap: 8 }}>
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteUser(record.id)}
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: "var(--color-error)",
                                    }}
                                />
                            }
                        >
                            <Button
                                type="text"
                                size="small"
                                icon={
                                    <DeleteOutlined
                                        style={{ color: "var(--color-error)" }}
                                    />
                                }
                                style={errorActionButtonStyle}
                            />
                        </Popconfirm>
                        <Button
                            type="text"
                            size="small"
                            icon={
                                <EditOutlined
                                    style={{ color: "var(--color-primary)" }}
                                    id={record.id}
                                    details={JSON.stringify(record)}
                                    onClick={editUser}
                                />
                            }
                            style={neutralActionButtonStyle}
                        />
                    </div>
                );
            },
        },
    ];

    const {
        status: vendorStatus,
        data: vendorRes,
        refetch: getVendor,
    } = useQuery(
        "dashboard-vendors",
        async () => {
            return await HTTP("/vendors/getVendors", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: hotelStatus,
        data: hotelData,
        refetch: getHotelSelectionOptions,
    } = useQuery(
        "analytics-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHotelSelectionOptions();
        getVendor();
    }, []);

    useEffect(() => {
        getVendor();
    }, [formData]);

    useEffect(() => {
        if (vendorStatus === "success") {
            const { data: vendorData, total } = vendorRes;
            setVendorData(vendorData);
            setTotalRecords(total);
        }
    }, [vendorStatus, vendorRes]);

    useEffect(() => {
        if (hotelStatus === "success") {
            setHotelOptions(hotelData.data);
        }
    }, [hotelStatus, hotelData]);

    async function deleteUser(id) {
        const formData = {
            staff_id,
            id,
        };
        const { success, message } = await HTTP(
            "/vendors/deleteVendor",
            formData,
        );
        if (success === 0) {
            return notification["error"]({
                message: message,
            });
        } else {
            notification["info"]({
                message: "Delete action performed successfully.",
            });
        }
        getVendor();
    }

    function editUser(e) {
        const details = JSON.parse(e.currentTarget.getAttribute("details"));
        setTitle("Edit");
        details.phone_number = details.country_code
            .concat(details.phone_number)
            .replace("+", "");
        setFormPhoneInputValue([details.country_code, details.phone_number]);
        form.setFieldsValue(details);
        setVisible(true);
    }

    function openAddVendorModel() {
        setTitle("Add");
        form.resetFields();
        setVisible(true);
    }

    function closeModel() {
        setVisible(false);
        setFormPhoneInputValue([]);
        form.resetFields();
    }

    async function handleSubmit(formData) {
        closeModel();
        formData.staff_id = staff_id;
        let url;
        if (formData.id) {
            url = "/vendors/editVendor";
        } else {
            url = "/vendors/addVendor";
            delete formData["id"];
        }
        const [country_code, phone_number] = formPhoneInputValue;
        formData.country_code = country_code;
        formData.phone_number = phone_number;
        const { success, message } = await HTTP(url, formData);
        let type = "info";
        if (success === 0) {
            type = "error";
        }
        notification[type]({
            message: message,
        });
        getVendor();
    }

    function handlePhoneInputChange(value, country, e, formattedValue) {
        setFormPhoneInputValue([
            `+${country.dialCode}`,
            value.replace(country.dialCode, ""),
        ]);
    }

    function handleTableChange(pagination, filters, sorter, extra) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
            sort_by: "id",
            sorting: 1,
            ...(filters?.vendor_type ? { filters } : { filters: {} }),
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        const formData = {
            staff_id,
            ...others,
        };
        setFormData(formData);
    }

    function handleSearchInputSubmit() {
        const updatedFormData = { ...formData, search_by: searchKey };
        setFormData(updatedFormData);
    }

    function handleSearchInputChange(event) {
        setSearchKey(event.target.value);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (userRole === "Super Admin" ||
                            userRole === "Admin" ||
                            userRole === "Customer Success" ||
                            userRole == "Support") && (
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={openAddVendorModel}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        )
                    }
                />
                <Card
                    className="box-shadow margin-10"
                    title={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Input
                                placeholder="Search By"
                                style={{ width: "20%" }}
                                className="margin-right-10"
                                value={searchKey}
                                onChange={handleSearchInputChange}
                            />
                            <Button
                                type="primary"
                                onClick={handleSearchInputSubmit}
                            >
                                Search
                            </Button>
                        </div>
                    }
                >
                    {vendorStatus === "loading" || vendorStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={vendorData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="vendor-table"
                            isScroll
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={
                    <div className="vendor-modal-header">
                        <div>
                            <div className="vendor-modal-title">
                                {title === "Add" ? "Add Vendor" : "Edit Vendor"}
                            </div>
                            <div className="vendor-modal-subtitle">
                                Manage vendor details, linked hotels, contact
                                information, and notes.
                            </div>
                        </div>
                    </div>
                }
                open={visible}
                footer=""
                onCancel={closeModel}
                destroyOnHidden
                className="vendor-modal"
                width={760}
            >
                <Form
                    form={form}
                    name="basic"
                    layout="vertical"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    className="vendor-form"
                >
                    <Form.Item label="Id" name="id" className="hidden">
                        <Input id="id" disabled />
                    </Form.Item>

                    <div className="vendor-form-section">
                        <div className="vendor-form-section-title">
                            Vendor Info
                        </div>
                        <div className="vendor-form-grid">
                            <Form.Item
                                label="Vendor Name"
                                name="vendor_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter vendor name!",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Vendor Name"
                                    id="vendor_name"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Person Name"
                                name="person_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter person name!",
                                    },
                                ]}
                            >
                                <Input
                                    placeholder="Person Name"
                                    id="person_name"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Email"
                                name="person_email"
                                rules={[
                                    {
                                        type: "email",
                                        required: true,
                                        message: "Please enter email!",
                                    },
                                ]}
                            >
                                <Input placeholder="Email" id="person_email" />
                            </Form.Item>

                            <Form.Item
                                label="Vendor Type"
                                name="vendor_type"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select vendor Type..!",
                                    },
                                ]}
                            >
                                <Select
                                    id="vendor_type"
                                    placeholder="Vendor Type"
                                >
                                    {vendorTypes.map((v) => (
                                        <Option key={v.key} value={v.key}>
                                            {v.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>

                    <div className="vendor-form-section">
                        <div className="vendor-form-section-title">
                            Contacts & Hotels
                        </div>
                        <div className="vendor-form-grid">
                            <Form.Item label="Hotels" name="hotel_id">
                                <Select
                                    id="hotel_id"
                                    placeholder="Hotel Name"
                                    showSearch
                                    mode="multiple"
                                    filterOption={(input, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    loading={hotelOptions.length == 0}
                                >
                                    {hotelOptions.map((h) => (
                                        <Option
                                            key={h.hotel_id || h.id}
                                            value={h.hotel_id || h.id}
                                        >
                                            {`${h.hotel_id || h.id} - ${
                                                h.hotel_name || h.name
                                            } - ${h.city}`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item
                                label="Phone"
                                name="phone_number"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter phone!",
                                    },
                                ]}
                            >
                                <PhoneInput
                                    onChange={handlePhoneInputChange}
                                    placeholder="Phone"
                                    id="phone_number"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Notes"
                                name="notes"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter notes!",
                                    },
                                ]}
                                className="vendor-form-grid-span-2"
                            >
                                <Input.TextArea
                                    placeholder="Notes"
                                    id="notes"
                                    rows={4}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <Form.Item className="vendor-form-submit">
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { VendorList };
